var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"flex justify-end pt-2"},[_c('a',{staticClass:"px-2 hover:text-dbm-red",attrs:{"href":"/"}},[_vm._v("English")]),_vm._v(" | "),_c('a',{staticClass:"px-2 hover:text-dbm-red",attrs:{"href":"/bm"}},[_vm._v("Bahasa Malaysia")])])])])
}]

export { render, staticRenderFns }